import { z } from 'zod'
import interceptedAxios from '../../../../utils/interceptedAxios'
import { ZHybridKek } from '../../types'

const ZHybridKekObj = z.object({
  total_count: z.number(),
  list: z.array(ZHybridKek)
})

const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZHybridKekObj)
})

export type HybridKekObj = z.infer<typeof ZHybridKekObj>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function getHybridKekList (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  onSuccess: (hybridKekObj: HybridKekObj, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  let field = sortfield
  if (field === 'label') {
    field = 'label'
  } else if (field === 'tenant') {
    field = 'wrapper.tenant'
  } else if (field === 'regular Wrapping Key') {
    field = 'wrapperId'
  } else if (field === 'created At') {
    field = 'createdAt'
  } else if (field === 'created By') {
    field = 'createdBy'
  }
  const url = `/app-config-service/api/v1/crypto/hybrid-keks-db?page=${page}&size=${size}&sort=${field},${sortdir}&input=${input}`
  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore next
      if (parseResponse.success) {
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure({ totalCount: 0, list: [] }, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        // istanbul ignore next
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
